(function() {
    angular.module('tmx-app').factory('TreasuryService', ['tmxResource',
        function(tmxResource) {
            var TreasuryServiceDetail = tmxResource("TreasuryServiceDetail");

            TreasuryServiceDetail.gridColumn = [{
                field: "CustomerName",
                title: "CustomerName",
                type: "text",
                headerTemplate: "<span>{{'CustomerName' | translate}}<i class='fa fa-filter' ng-if='TreasuryCtrl.isFiltered(\"CustomerName\")' ></i></span>"
            },
            {
                field: "LoanApplicationNumber",
                title: "LoanApplicationNumber",
                type: "text",
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : TreasuryCtrl.isFiltered('LoanApplicationNumber')}\" >{{'LoanApplicationNumber' | translate}}<i class='fa fa-filter' ng-if='TreasuryCtrl.isFiltered(\"LoanApplicationNumber\")' ></i></span>"
            },
            {
                field: "ProductName",
                title: "ProductName",
                type: "text",
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : TreasuryCtrl.isFiltered('ProductName')}\" >{{'ProductName' | translate}}<i class='fa fa-filter' ng-if='TreasuryCtrl.isFiltered(\"ProductName\")' ></i></span>"
            },
            {
                field: "LoanType",
                title: "LoanType",
                template: '<select kendo-drop-down-list k-value-primitive="true" k-options="TreasuryCtrl.loanTypeOptions" k-ng-model="dataItem.LoanType"  style="width: 100%" k-ng-disabled="true"></select>'
            },
            {
                field: "CreatedBy",
                title: "CreatedBy",
                type: "text",
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : TreasuryCtrl.isFiltered('CreatedBy')}\" >{{'CreatedBy' | translate}}<i class='fa fa-filter' ng-if='TreasuryCtrl.isFiltered(\"CreatedBy\")' ></i></span>"
            },
            {
                field: "BranchName",
                title: "BranchName",
                type: "text",
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : TreasuryCtrl.isFiltered('BranchName')}\" >{{'BranchName' | translate}}<i class='fa fa-filter' ng-if='TreasuryCtrl.isFiltered(\"BranchName\")' ></i></span>"
            },
            {
                field: "ApprovedLoanAmount",
                title: "Approved Loan Amount",
                type: "number",
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : TreasuryCtrl.isFiltered('ApprovedLoanAmount')}\" >{{'ApprovedLoanAmount' | translate}}<i class='fa fa-filter' ng-if='TreasuryCtrl.isFiltered(\"ApprovedLoanAmount\")' ></i></span>"
            },
            {
                field: "TotalInstallments",
                title: "TotalInstallments",
                type: "number",
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : TreasuryCtrl.isFiltered('TotalInstallments')}\" >{{'TotalInstallments' | translate}}<i class='fa fa-filter' ng-if='TreasuryCtrl.isFiltered(\"TotalInstallments\")' ></i></span>"
            },
            {
                field: "LoanPurpose",
                title: "LoanPurpose",
                type: "text",
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : TreasuryCtrl.isFiltered('LoanPurpose')}\" >{{'LoanPurpose' | translate}}<i class='fa fa-filter' ng-if='TreasuryCtrl.isFiltered(\"LoanPurpose\")' ></i></span>"
            },
            {
                command: [{
                    template: "<span class='k-button' style='border-radius: 99px;' ng-click='TreasuryCtrl.submitClick(this.dataItem)'>Edit</span>"
                }],
                title: " ",
                width: "100px",
            }
            ];

            TreasuryServiceDetail.columns = angular.copy(TreasuryServiceDetail.gridColumn);

            return TreasuryServiceDetail;
        }
    ]);
})();